import { IEnumerable } from "./ModelHelpers";

export const NOTIFICATION_CHANNEL_EMAIL = 1;
export const NOTIFICATION_CHANNEL_PUSH = 2;

export const NOTIFICATION_CHANNELS = [
  NOTIFICATION_CHANNEL_EMAIL,
  NOTIFICATION_CHANNEL_PUSH,
] as const;

export type notificationChannel = typeof NOTIFICATION_CHANNELS[number];

type NotificationChannelModel = {
  notificationChannel: notificationChannel;
  id: IEnumerable;
};

export default NotificationChannelModel;

export function getNotificationChannelFromEnum(channel: notificationChannel) {
  switch (channel) {
    case NOTIFICATION_CHANNEL_EMAIL:
      return "E-mail";

    case NOTIFICATION_CHANNEL_PUSH:
      return "Push";

    default:
      // eslint-disable-next-line no-console
      console.error("getNotificationChannelString → rule not valid! Returning empty!");
      return "";
  }
}
